import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from './encyption.service';
import { isPlatformBrowser, Location } from '@angular/common';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';
import { CarrentCardFilters } from '@app/models/carrent/CarrentCardFilters';
@Injectable({
    providedIn: 'root',
})
export class CarrentFiltersService {
    protected filters: BehaviorSubject<CarrentFilters>;
    protected tmp_objFilter = {} as CarrentCardFilters;
    protected objFilter: CarrentFilters = {} as CarrentFilters;
    protected extrasCount: BehaviorSubject<number>;
    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected encservice: EncryptionService,
        protected location: Location,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.filters = new BehaviorSubject(null);
        this.extrasCount = new BehaviorSubject(0);
        this.objFilter = {} as CarrentFilters;
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => {
                this.initFilters();
            }, 50);
        }
    }

    get getfilters$() {
        return this.filters.asObservable();
    }

    initFilters(): void {
        if (this.route.snapshot.queryParams['params'] && this.route.snapshot.queryParams['params'].length > 0) {
            const tokenFromUI = this.route.snapshot.queryParams['params']?.slice(-16);
            const data = this.route.snapshot.queryParams['params']?.slice(0, (this.route.snapshot.queryParams['params'].length - 16));
            this.tmp_objFilter = JSON.parse(this.encservice.deencrypt(tokenFromUI, data));
            this.initLoadFilter();
        } else {
            if (!this.objFilter?.productType) {
                this.setDefault();
            }
        }
    }

    setDefault(): void {
        this.objFilter.productType = 'carrent';
        this.objFilter.searchDate = '7, 14';
        this.objFilter.startNum = 7;
        this.objFilter.endNum = 14;
        this.objFilter.adults = '2';
        this.objFilter.startTime = '12:00';
        this.objFilter.endTime = '12:00';
        this.objFilter.arrivalAirportList = null;
        this.filters.next(this.objFilter);
    }

    resetAllExtraFilters(field, sel): void {
        if (sel?.length > 0) { // if as [] => from anfrage tools
            const tt = [];
            for (let i = 0; i < sel.length; i++) {
                tt.push({
                    code: sel[i],
                    selected: true
                });
            }
            sel = {
                filterList: tt
            };
        }
        for (let i = 0; i < this.objFilter?.filters?.[field]?.filterList?.length; i++) {
            for (let j = 0; j < sel?.filterList?.length; j++) {
                if (sel?.filterList[j].code === this.objFilter.filters[field].filterList[i].code) {
                    this.objFilter.filters[field].filterList[i].selected = false || sel?.filterList[j].selected;
                }
            }
        }
    }

    resetAllExtrasHome(): void {
        this.resetAllExtraFilters('pkt', this.tmp_objFilter?.filters?.pkt);
        this.resetAllExtraFilters('trg', this.tmp_objFilter?.filters?.trg);
        this.resetAllExtraFilters('inc', this.tmp_objFilter?.filters?.inc);
        this.resetAllExtraFilters('ins', this.tmp_objFilter?.filters?.ins);
        this.resetAllExtraFilters('fkl', this.tmp_objFilter?.filters?.fkl);
        this.resetAllExtraFilters('fty', this.tmp_objFilter?.filters?.fty);
        this.resetAllExtraFilters('opi', this.tmp_objFilter?.filters?.opi);
        this.setDefault();
    }

    setExtras(extras) {
        if (!this.objFilter.filters) {
            this.objFilter.filters = extras?.filters;
            this.resetAllExtraFilters('pkt', this.tmp_objFilter?.filters?.pkt);
            this.resetAllExtraFilters('trg', this.tmp_objFilter?.filters?.trg);
            this.resetAllExtraFilters('inc', this.tmp_objFilter?.filters?.inc);
            this.resetAllExtraFilters('ins', this.tmp_objFilter?.filters?.ins);
            this.resetAllExtraFilters('fkl', this.tmp_objFilter?.filters?.fkl);
            this.resetAllExtraFilters('fty', this.tmp_objFilter?.filters?.fty);
            this.resetAllExtraFilters('opi', this.tmp_objFilter?.filters?.opi);
            // this.filters.next(this.objFilter);
        }
    }

    resetExtraforletters() {
        this.tmp_objFilter = null;
        this.resetAllExtraFilters('pkt', '');
        this.resetAllExtraFilters('trg', '');
        this.resetAllExtraFilters('inc', '');
        this.resetAllExtraFilters('ins', '');
        this.resetAllExtraFilters('fkl', '');
        this.resetAllExtraFilters('fty', '');
        this.resetAllExtraFilters('opi', '');
        this.objFilter.startTime = '12:00';
        this.objFilter.endTime = '12:00';
        this.filters.next(this.objFilter);
    }

    onlySetRealParams(params: CarrentCardFilters) {
        this.objFilter.productType = 'carrent';
        this.objFilter.searchDate = params?.searchDate?.length > 0 ? params.searchDate : '7, 14';
        this.objFilter.startNum = params?.startNum > 0 ? params.startNum : 7;
        this.objFilter.endNum = params?.endNum > 0 ? params.endNum : 14;
        this.objFilter.adults = params?.adults?.length > 0 ? params.adults : '2';
        this.objFilter.startTime = params?.startTime?.length > 0 ? params.startTime : '12:00';
        this.objFilter.endTime = params?.endTime?.length > 0 ? params.endTime : '12:00';
        this.objFilter.tourOperatorList = '';
        this.objFilter.arrivalAirportList = params?.arrivalAirportList?.code?.length > 0 ? params.arrivalAirportList : null;
        if (this.objFilter.filters) {
            this.setExF('pkt', params?.filters.pkt);
            this.setExF('trg', params?.filters.trg);
            this.setExF('inc', params?.filters.inc);
            this.setExF('ins', params?.filters.ins);
            this.setExF('fkl', params?.filters.fkl);
            this.setExF('fty', params?.filters.fty);
            this.setExF('opi', params?.tourOperatorList);
        }
        this.filters.next(this.objFilter);
    }

    setExF(filed, setData) {
        if (this.objFilter.filters?.[filed]?.filterList?.length > 0 && setData?.length > 0) {
            for (let j = 0; j < this.objFilter.filters[filed].filterList.length; j++) {
                this.objFilter.filters[filed].filterList[j].selected = setData.indexOf(this.objFilter.filters[filed].filterList[j].code) >= 0;
            }
        }
    }

    setExtraCount(value) {
        this.extrasCount.next(value);
    }

    get extrasCount$(): Observable<number> {
        return this.extrasCount.asObservable();
    }

    setFilters(objFilter) {
        this.objFilter = JSON.parse(JSON.stringify(objFilter));
        this.filters.next(this.objFilter);
        this.changeUrl();
    }

    tourOperatorListResult(ev, home) {
        this.objFilter.tourOperatorList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    productType(value, home) {
        this.objFilter.productType = value;
        if (!home) {
            this.changeUrl();
        }
    }

    incResult(ev, home) {
        this.objFilter.filters.inc.filterList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    insResult(ev, home) {
        this.objFilter.filters.ins.filterList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    ftyResult(ev, home) {
        this.objFilter.filters.fty.filterList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    fieldResult(ev, home, field) {
        this.objFilter.filters[field].filterList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    opiResult(ev, home) {
        this.objFilter.filters.opi.filterList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    fklResult(ev, home) {
        this.objFilter.filters.fkl.filterList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    pktResult(ev, home) {
        this.objFilter.filters.pkt.filterList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    trgResult(ev, home) {
        this.objFilter.filters.trg.filterList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    arrivalAirportList(ev, home): void {
        this.objFilter.arrivalAirportList = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    carrentdatevonf(ev, home): void {
        this.objFilter.startNum = 0;
        this.objFilter.endNum = 0;
        this.objFilter.start = ev?.start;
        this.objFilter.end = ev?.end;
        this.objFilter.searchDate = ev?.start + ',' + ev?.end;
        if (!home) {
            this.changeUrl();
        }
    }

    carrentstartTime(ev, home): void {
        this.objFilter.startTime = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    carrentendTime(ev, home): void {
        this.objFilter.endTime = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    carrentreisendef(ev, home): void {
        this.objFilter.adults = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    carrenttypef(ev, home): void {
        this.objFilter.filters.fkl = ev;
        if (!home) {
            this.changeUrl();
        }
    }

    changeUrl() {
        this.initParamFilter();
        const url = this.router.createUrlTree([], { queryParams: { params: this.encservice.encrypt(this.objFilter), replaceUrl: true } }).toString();
        this.location.replaceState(url);
        this.filters.next(this.objFilter);
    }

    setOnlyNext() {
        this.filters.next(this.objFilter);
    }

    setReference(reference) {
        this.objFilter.reference = reference;
    }

    gotoUrl(): void {
        this.initParamFilter();
        const url = this.router.createUrlTree(['carrent'], { queryParams: { params: this.encservice.encrypt(this.objFilter), replaceUrl: true } }).toString();
        this.router.navigateByUrl(url);
        this.filters.next(this.objFilter);
    }

    initParamFilter(): void {
        this.tmp_objFilter = {} as CarrentCardFilters;
        if (!this.objFilter.arrivalAirportList) {
            this.tmp_objFilter.arrivalAirportList = {
                name: 'Mallorca',
                code: 'PMI'
            }
        } else {
            this.tmp_objFilter.arrivalAirportList = {
                name: this.objFilter.arrivalAirportList.name,
                code: this.objFilter.arrivalAirportList.code
            }
        }
        this.tmp_objFilter.productType = 'carrent';
        this.tmp_objFilter.searchDate = this.objFilter?.searchDate?.length > 0 ? this.objFilter.searchDate : '';
        this.tmp_objFilter.startNum = this.objFilter?.startNum > 0 ? this.objFilter.startNum : 0;
        this.tmp_objFilter.endNum = this.objFilter?.endNum > 0 ? this.objFilter.endNum : 0;
        this.tmp_objFilter.adults = this.objFilter?.adults?.length > 0 ? this.objFilter.adults : '2';
        this.tmp_objFilter.startTime = this.objFilter?.startTime?.length > 0 ? this.objFilter.startTime : '12:00';
        this.tmp_objFilter.endTime = this.objFilter?.endTime?.length > 0 ? this.objFilter.endTime : '12:00';
        this.tmp_objFilter.tourOperatorList = '';
        this.tmp_objFilter.arrivalAirportList = this.objFilter?.arrivalAirportList?.code?.length > 0 ? this.objFilter.arrivalAirportList : null;
        this.tmp_objFilter.filters = {};
        if (this.objFilter.filters) {
            this.initFF('pkt');
            this.initFF('trg');
            this.initFF('inc');
            this.initFF('ins');
            this.initFF('fkl');
            this.initFF('fty');
            this.initFF('opi');
        }
    }

    initFF(field) {
        this.tmp_objFilter.filters[field] = '';
        for (let j = 0; j < this.objFilter?.filters?.[field]?.filterList.length; j++) {
            if (this.objFilter.filters[field].filterList[j].selected) {
                this.tmp_objFilter.filters[field] += this.objFilter.filters[field].filterList[j].code + '';
            }
        }
    }

    initLoadFilter(): void {
        if (!this.objFilter) {
            this.objFilter = {} as CarrentFilters;
        }
        if (!this.tmp_objFilter.arrivalAirportList) {
            this.objFilter.arrivalAirportList = {
                name: 'Mallorca',
                code: 'PMI'
            }
        } else {
            this.objFilter.arrivalAirportList = {
                name: this.tmp_objFilter.arrivalAirportList.name,
                code: this.tmp_objFilter.arrivalAirportList.code
            }
        }
        this.objFilter.productType = 'carrent';
        this.objFilter.searchDate = this.tmp_objFilter?.searchDate?.length > 0 ? this.tmp_objFilter.searchDate : '';
        this.objFilter.start = this.tmp_objFilter?.start?.length > 0 ? this.tmp_objFilter.start : '';
        this.objFilter.end = this.tmp_objFilter?.end?.length > 0 ? this.tmp_objFilter.end : '';
        this.objFilter.startNum = this.tmp_objFilter?.startNum > 0 ? this.tmp_objFilter.startNum : 0;
        this.objFilter.endNum = this.tmp_objFilter?.endNum > 0 ? this.tmp_objFilter.endNum : 0;
        this.objFilter.adults = this.tmp_objFilter?.adults?.length > 0 ? this.tmp_objFilter.adults : '2';
        this.objFilter.startTime = this.tmp_objFilter?.startTime?.length > 0 ? this.tmp_objFilter.startTime : '12:00';
        this.objFilter.endTime = this.tmp_objFilter?.endTime?.length > 0 ? this.tmp_objFilter.endTime : '12:00';
        this.objFilter.tourOperatorList = '';
        this.objFilter.arrivalAirportList = this.tmp_objFilter?.arrivalAirportList?.code?.length > 0 ? this.tmp_objFilter.arrivalAirportList : null;
        this.filters.next(this.objFilter);
    }
}
